import script from "./VergleichKinder.vue?vue&type=script&setup=true&lang=js"
export * from "./VergleichKinder.vue?vue&type=script&setup=true&lang=js"

import "./VergleichKinder.vue?vue&type=style&index=0&id=2808b5c7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2808b5c7"]])

export default __exports__